import {
  Box,
  Button,
  Center,
  Flex,
  Image,
  Link,
  Skeleton,
  Text,
  useBreakpointValue
} from "@chakra-ui/react";
import { MdDoubleArrow, MdOutlineDoubleArrow } from "react-icons/md";
import Slider from "react-slick";

import { Rating } from "@/components/Rating";
import { useLoading } from "@/contexts/LoadingContext";
import { useCarouselContents } from "@/hooks/Contents";
import { CarouselContentsArray } from "@/types";
import { formatPrice, shoppingImagePath } from "@/utils";
import { useEffect, useState } from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

type CarouselProductsprops = {
  title?: string;
  color?: string;
  loading?: boolean;
  display?: boolean;
};

type Product = {
  img: string;
  url: string;
  title: string;
  model: string;
  price: string;
  reviews: number;
  rating: number;
  categoryImage?: string;
  generalGrade?: number;
  reviewCount?: number;
};

export function CarouselProductsMobile({ title, color, loading, display }: CarouselProductsprops) {
  const isWide = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });
  const { setActionIsLoading } = useLoading();

  const [ListProducts, setListProducts] = useState<CarouselContentsArray>(
    null as CarouselContentsArray
  );

  const [CarouselResponse, CarouselError, CarouselLoading] = useCarouselContents();

  useEffect(() => {
    if (CarouselResponse && CarouselError === null) {
      setListProducts(CarouselResponse?.[0]?.contentsArray);
    }
  }, [CarouselResponse]);

  function ArrowProductsPrev(props) {
    const { className, style, onClick } = props;
    return (
      <>
        {isWide && (
          <MdOutlineDoubleArrow
            className={className}
            fill={"#FF003A"}
            style={{
              ...style,
              display: "block",
              margin: " 0",
              color: "#0766c7 !important",
              transform: "rotateY(180deg) translateY(-10px)"
            }}
            onClick={onClick}
          />
        )}
      </>
    );
  }

  function ArrowProductsNext(props) {
    const { className, style, onClick } = props;
    return (
      <>
        {isWide && (
          <MdDoubleArrow
            className={className}
            style={{
              ...style,
              display: "block",
              margin: "0",
              color: "#0766c7 !important"
            }}
            fill={"#FF003A"}
            onClick={onClick}
          />
        )}
      </>
    );
  }

  const settings = {
    arrows: true,
    dots: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 5000,
    adaptiveHeight: false,
    centerMode: false,
    nextArrow: <ArrowProductsNext />,
    prevArrow: <ArrowProductsPrev />,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrow: true
        }
      },
      ,
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrow: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  };

  const renderSlides = () =>
    ListProducts.map((slide, index) => (
      <Flex key={index} h="full" paddingLeft={"10px"}>
        {loading ? (
          <Flex w={"190px"} h="390px" mr={"10px"}>
            <Skeleton w={"full"} height={"full"} borderRadius={"10px"} />
          </Flex>
        ) : (
          <Flex
            justify="center"
            w={"190px"}
            bgColor={"ll-white.main"}
            border={"1px solid"}
            borderColor={"ll-gray.100"}
            borderRadius={"10px"}
          >
            <Link
              href={`https://www.pneufree.com.br/linglong/${slide.Url}`}
              _hover={{ textDecoration: "none", opacity: "0.5" }}
              _focus={{ border: "none" }}
              mb="15px"
            >
              <Flex
                position={"relative"}
                w={"full"}
                h="390px"
                direction="column"
                alignItems="center"
              >
                <Flex w={"100%"} direction="column" align={"center"} justify={"center"}>
                  <Box h={"180px"} marginBottom={"10px"} marginTop={"5px"}>
                    <Image
                      loading="lazy"
                      borderTopRadius={"6px"}
                      src={shoppingImagePath(slide.Img)}
                      alt={slide.Model}
                      width={"170px"}
                      height={"170px"}
                      onError={(e) =>
                        (e.currentTarget.src =
                          "https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/pneu-default.png")
                      }
                    />
                  </Box>
                  <Text
                    justifyContent={"center"}
                    align={"center"}
                    fontSize={"h3"}
                    color={"ll-gray.300"}
                    fontWeight={"600"}
                    letterSpacing={"-1px"}
                  >
                    {slide.Title}
                  </Text>

                  {slide.Model.includes("RUN FLAT") ? (
                    <Flex gap={"5px"} w={"full"} justifyContent={"center"}>
                      <Text
                        align={"center"}
                        fontWeight={"500"}
                        fontSize="text1"
                        color={"ll-blue.main"}
                      >
                        {slide.Model.split(" ", 1)}
                      </Text>
                      <Text
                        align={"center"}
                        fontWeight={"500"}
                        fontSize="text1"
                        color={"ll-red.main"}
                      >
                        {" "}
                        RUN FLAT
                      </Text>
                    </Flex>
                  ) : (
                    <Text
                      align={"center"}
                      fontWeight={"500"}
                      fontSize="text1"
                      color={"ll-blue.main"}
                    >
                      {slide.Model?.replace(slide.Title, "")
                        ?.replace("PNEU", "")
                        .replace("LINGLONG", "")}
                    </Text>
                  )}
                  <Flex></Flex>

                  <Box>
                    <Rating
                      number={false}
                      generalGrade={slide.Ratings}
                      reviewCount={slide.Reviews}
                    />
                  </Box>
                  <Flex mt={"5px"} alignItems={"center"} flexDir={"column"}>
                    <Text
                      fontSize={"h1"}
                      color={"ll-blue.main"}
                      fontWeight={"500"}
                      letterSpacing={"-3px"}
                    >
                      {formatPrice(parseFloat(slide.Price))}
                    </Text>
                    <Text mt={"-8px"} color={"ll-gray.300"} fontWeight={"400"}>
                      à vista.
                    </Text>
                  </Flex>

                  <Button variant={"primary-button"} mt={"10px"} w={"80%"}>
                    <Text>DETALHES</Text>
                  </Button>
                </Flex>
              </Flex>
            </Link>
          </Flex>
        )}
      </Flex>
    ));

  return (
    <Box
      display={["Flex", "none"]}
      flexDir={"column"}
      mt={"30px"}
      maxW="1200px"
      minH="390px"
      w="full"
      justifyContent="center"
      mb="2.5rem"
    >
      <Center
        mb={"15px"}
        color={"ll-blue.main"}
        fontSize={"h4"}
        fontWeight={"500"}
        letterSpacing={"2px"}
      >
        {title}
      </Center>
      <Slider {...settings}>{ListProducts ? renderSlides() : null}</Slider>
    </Box>
  );
}
